import React from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Link,
  // ModalCloseButton,
  ModalBody,
  ModalFooter,
  // Image,
} from '@chakra-ui/react';

// MOSTRA UN MODAL CON 
// TITLE, BODY
// Opzionale children
// Opzionale un pulsante di cancel se passi onCancel
// Opzionale url che viene associato al pulsante OK
export const ModalInfo = ({ title, body, isOpen, onClose, onCloseText = 'OK', onCancel, onCancelText = 'Annulla', url, children }) => {
  const hasCancelButton = !!onCancel;
  const hasUrl = !!url;

  // console.log('URL? ', url)
  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} blockScrollOnMount={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        {/* <ModalCloseButton /> */}
        <ModalBody>
          {body}
          {children}
        </ModalBody>
        <ModalFooter>
          {hasCancelButton && (
            <Button
              minWidth={125}
              size={'lg'}
              mr={3}
              onClick={onCancel}
              variant='secondary'
            >
              {onCancelText}
            </Button>
          )}
          {hasUrl ? (
              <Link href={url} style={{textDecoration: 'none'}}>
                <Button minWidth={125} size={'lg'} mr={3}>{onCloseText}</Button>
              </Link>
          ) : (
            <Button minWidth={125} size={'lg'} mr={3} onClick={onClose}>
              {onCloseText}
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
